import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionButton from './ActionButton';
import ButtonCollection from './ButtonCollection';
import { DeleteButton } from './ConfirmButton.js';

const AppliedFilter = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const filters = props?.filters ?? [];
	const in_layer = props?.in_layer ?? false;

	const calc_margin_top = () => {
		let tabs_height = parseInt($('.sticky_navigation').height()) - 1;
		if(isNaN(tabs_height)) tabs_height = 0;

		let filters_height = parseInt($('.filter_results_contents').height());
		if(isNaN(filters_height)) filters_height = 0;

		$('.entries_list').css({ marginTop:`${tabs_height + filters_height}px` });
	};

	if(!in_layer) calc_margin_top();

	if(!(filters.length > 0)) return null; //.filter((f) => f.filter.skipslots == undefined)

	const execute_function = (attrs) => {
		if(props.dispatch_function != undefined) {
			props.dispatch_function(attrs);
		}
	};

	const styleRibbonFilter = {
		overflow:'hidden',
		textOverflow:'ellipsis',
		maxWidth:'40em',
		lineHeight:'1.8em',
	};

	return (
		<div class="filter_results_contents">
			<ButtonCollection _class={{ other:'filter_togglers' }}>
				{filters.map((filter, i) => {
					let operator = filter?.operator ?? '=';

					if(filter.filter == undefined ) return null;

					let defaultMessage = `${i18n(filter.filter.name)} ${operator} ${filter.value}`;
					
					if(filter.filter.humanize != undefined) defaultMessage = filter.filter.humanize(filter);

					return (
						<ActionButton
							key={`filter${i}`}
							color="black"
							icon='knk-off'
							autotranslate={false}
							onClick={() => execute_function({ type:'REMOVEFILTER', filter:filter })}
							_class={{other:'gui_block gui_force_same_line'}}
							style={styleRibbonFilter}
						>{defaultMessage}</ActionButton>
					)}
				)}

				{(filters.length > 0) && (
					<DeleteButton
						onClick={() => execute_function({ type:'RESET_FILTERS' })}
					>Clear Filters</DeleteButton>
				)}
			</ButtonCollection>

			{(props.children != undefined) && (
				<div class="extra_content">{props.children}</div>
			)}
		</div>
	);
};

export default injectIntl(AppliedFilter);